import SubtypeCard from './SubtypeCard';

export default SubtypeCard;
